import { colorTokens, KariusLink } from '@kariusdx/design-system';
import { Alert, ButtonBase, Grid, Snackbar, Typography } from '@mui/material';
import { useState } from 'react';
import useLoginFooterStyles from './loginfooter.style';
import { EngagementEvents, logKariusEvent } from '../Analytics';
import KariusLogoFooter from '../assets/images/svg/KariusLogoFooter';
import { contactSupport } from '../Header/HeaderUtils';

export default function LoginFooter() {
  const styles = useLoginFooterStyles();

  return (
    <Grid
      css={styles.loginFooterContainer}
      container
      direction='column'
      alignItems='flex-start'
      id='login-footer-container'
    >
      <Grid item>
        <Grid item container direction='column' css={styles.logoContainer}>
          <KariusLogoFooter data-test='karius-footer-logo' />
          <Grid data-test='footer-clia' item>
            <Typography variant='caption' css={{ color: colorTokens.text_05 }}>
              CLIA #05D2121236
            </Typography>
          </Grid>
          <Grid data-test='footer-cap' item>
            <Typography variant='caption' css={{ color: colorTokens.text_05 }}>
              CAP #9497749
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <FooterLink title='Home' href='https://kariusdx.com/' event='home' />
      <FooterLink title='Privacy Policy' href='https://kariusdx.com/privacy-policy/' event='privacy' />
      <FooterLink title='Licensure' href='https://kariusdx.com/licensure/' event='licensure' />
      <FooterLink
        title='Lab & Physician Instructions'
        href='https://karius.showpad.com/share/eMdS8q9YeDVU1NyoHG4aS'
        event='lab_phy_instructions'
      />
      <Grid item data-test='footer-contact'>
        Contact
        <Grid container direction='column'>
          <ContactOption title='Phone: (866) 452-7487' link='phone' />
          <ContactOption title='Fax: (866) 246-6567' link='fax' />
          <ContactOption title='help@kariusdx.com' link='email' />
        </Grid>
      </Grid>
    </Grid>
  );
}

const ContactOption = ({ title, link }: { title: string; link: 'phone' | 'fax' | 'email' }) => {
  const [showAlert, setShowAlert] = useState(false);
  return (
    <Grid data-test={link} item>
      <ButtonBase
        css={{ userSelect: 'text' }}
        onClick={() => {
          logKariusEvent(EngagementEvents.footer_link_tapped, { link });
          contactSupport(link);
          if (link === 'fax') setShowAlert(true);
        }}
      >
        {title}
      </ButtonBase>
      <Snackbar open={showAlert} onClose={() => setShowAlert(false)} autoHideDuration={3000}>
        <Alert severity='info' onClose={() => setShowAlert(false)}>
          Text copied to clipboard
        </Alert>
      </Snackbar>
    </Grid>
  );
};

interface FooterLinkInterface {
  title: string;
  href: string;
  event: 'home' | 'privacy' | 'licensure' | 'lab_phy_instructions';
}

const FooterLink = ({ title, href, event }: FooterLinkInterface) => {
  const styles = useLoginFooterStyles();

  return (
    <Grid css={styles.footerLinks} item>
      <KariusLink
        data-test={event}
        href={href}
        underline
        style={{ color: colorTokens.text_05 }}
        target='_blank'
        variant='body_01'
        rel='noreferrer'
        onClick={() => logKariusEvent(EngagementEvents.footer_link_tapped, { link: event })}
      >
        {title}
      </KariusLink>
    </Grid>
  );
};
